import { MARQUEE_ITEMS } from "@/lib/site";

const Diamond = () => (
    <svg viewBox="0 0 10 10" className="h-2 w-2 text-brass" fill="currentColor" aria-hidden="true">
        <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" />
    </svg>
);

export const Marquee = () => (
    <div className="overflow-hidden border-y border-brass/25 bg-ivory py-5" data-testid="editorial-marquee">
        <div className="flex w-max animate-marquee">
            {[0, 1].map((track) => (
                <div key={track} aria-hidden={track === 1} className="flex items-center">
                    {MARQUEE_ITEMS.map((item) => (
                        <span key={`${track}-${item}`} className="flex items-center">
                            <span className="px-8 font-serif text-lg uppercase tracking-[0.2em] text-navy/70 sm:text-xl">
                                {item}
                            </span>
                            <Diamond />
                        </span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);
